import BankDetailsForm from "./Form"

function BankDetails() {
    return (
       <BankDetailsForm></BankDetailsForm>
    )
}

export default BankDetails
